import { render } from "./ChartSlices.vue?vue&type=template&id=63f2b10f"
import script from "./ChartSlices.vue?vue&type=script&lang=js"
export * from "./ChartSlices.vue?vue&type=script&lang=js"

import "./ChartSlices.vue?vue&type=style&index=0&id=63f2b10f&lang=scss"
script.render = render

export default script